export enum SurveyEditDisplayTypes {
    Videos = 'videos',
    Visuals = 'visuals',
    Assessment = 'assessment',
    PointCloud = 'pointcloud',
    Documents = 'documents',
    Summary = 'summary',
    Report = 'report',
}
